import actions from '../../actionTypes';

export default sites => {
  return {
    type: actions.SET_SITES,
    sites
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/setSites.js